import { useState, useEffect } from "react";

export default function Intro() {
  // Decide visibility synchronously; do NOT write sessionStorage here (lazy init runs twice in StrictMode).
  const [show, setShow] = useState(() => !sessionStorage.getItem("nh_intro_seen"));
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("nh_intro_seen", "1");
    // Start fade-out at 2.4s, hard-unmount by 3s no matter what.
    const fadeTimer = setTimeout(() => setExiting(true), 2400);
    const killTimer = setTimeout(() => setShow(false), 3000);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(killTimer);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="intro-overlay"
      onClick={() => setShow(false)}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black nh-grid-bg"
      style={{
        opacity: exiting ? 0 : 1,
        transition: "opacity 0.6s ease-in-out",
        pointerEvents: exiting ? "none" : "auto",
      }}
    >
      <h1 className="nh-intro-word font-mono font-extrabold text-3xl sm:text-5xl lg:text-7xl tracking-tight text-center px-6">
        <span className="text-nhorange text-glow-orange">DOBRO</span>
        <span className="text-nhgreen text-glow-green">DOŠLI</span>
      </h1>
      <div className="nh-intro-sub font-mono text-white/50 text-xs sm:text-sm tracking-[0.4em] uppercase mt-6">
        NAŠA HUB
      </div>
    </div>
  );
}
